// events.ts — normalises the EngineEvent discriminated union into a flat row shape for
// the events ledger table (Datum, Typ, Betrag, KESt, Kontostand danach).
import type { EngineEvent } from '@etf-cockpit/engine';

export interface EventRow {
  date: string;
  typeLabel: string;
  amountCents: number;
  kestCents: number | null;
  settlementAfterCents: number;
}

const TYPE_LABELS: Record<EngineEvent['type'], string> = {
  contribution: 'Einzahlung',
  growth: 'Kursentwicklung',
  ter: 'TER',
  age: 'Ausschüttungsgleiche Erträge',
  oekbMeldung: 'OeKB-Meldung',
  distribution: 'Ausschüttung',
  returnOfCapital: 'Substanzauszahlung',
  pauschal: 'Pauschalbesteuerung',
  sale: 'Verkauf',
  partialSale: 'Entnahme (Teilverkauf)',
};

export function describeEvent(event: EngineEvent): EventRow {
  const base = { date: event.date, typeLabel: TYPE_LABELS[event.type], settlementAfterCents: event.settlementAfterCents };
  switch (event.type) {
    case 'contribution':
      return { ...base, amountCents: event.investedCents, kestCents: null };
    case 'growth':
      return { ...base, amountCents: event.deltaCents, kestCents: null };
    case 'ter':
      return { ...base, amountCents: -event.terCents, kestCents: null };
    case 'age':
      return { ...base, amountCents: event.grossCents, kestCents: event.kestCents };
    case 'oekbMeldung':
      return { ...base, amountCents: event.ageTaxableCents, kestCents: event.kestCents };
    case 'distribution':
      return { ...base, amountCents: event.netCents, kestCents: event.kestCents };
    case 'returnOfCapital':
      return { ...base, amountCents: event.grossCents, kestCents: null };
    case 'pauschal':
      return { ...base, amountCents: event.deemedGrossCents, kestCents: event.kestCents };
    case 'sale':
      return { ...base, amountCents: event.proceedsCents, kestCents: event.kestCents };
    case 'partialSale':
      return { ...base, amountCents: event.proceedsCents, kestCents: event.kestCents };
  }
}
